// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./font/URWDINCond-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./font/URWDINCond-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./font/URWDINCond-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./font/URWDINCond-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./font/URWDINCond-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "URW DIN Cond", sans-serif;
}
/* 
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
} */

/* @font-face {
  font-family: "URW Din Condensed";
  src: url("./font/urw-din-condensed.woff2") format("woff2"),
    url("./font/urw-din-condensed.woff") format("woff");
}

@font-face {
  font-family: "URW Din";
  src: url("./font/urw-din.woff2") format("woff2"),
    url("./font/urw-din.woff") format("woff");
}

@font-face {
  font-family: "Cairo";
  src: url("./font/Cairo-Regular.ttf") format("truetype");
} */

@font-face {
  font-family: "URW DIN Cond";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: local("./font/URW DIN Cond Light"), local("URWDINCond-Medium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 500;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,uCAAuC;AACzC;AACA;;;;GAIG;;AAEH;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,2BAA2B;EAC3B,4CAAuC;EACvC;;;;8DAIwD;EACxD,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["body {\n  margin: 0;\n  font-family: \"URW DIN Cond\", sans-serif;\n}\n/* \ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n} */\n\n/* @font-face {\n  font-family: \"URW Din Condensed\";\n  src: url(\"./font/urw-din-condensed.woff2\") format(\"woff2\"),\n    url(\"./font/urw-din-condensed.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"URW Din\";\n  src: url(\"./font/urw-din.woff2\") format(\"woff2\"),\n    url(\"./font/urw-din.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Cairo\";\n  src: url(\"./font/Cairo-Regular.ttf\") format(\"truetype\");\n} */\n\n@font-face {\n  font-family: \"URW DIN Cond\";\n  src: url(\"./font/URWDINCond-Light.eot\");\n  src: local(\"./font/URW DIN Cond Light\"), local(\"URWDINCond-Medium\"),\n    url(\"./font/URWDINCond-Medium.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"./font/URWDINCond-Medium.woff2\") format(\"woff2\"),\n    url(\"./font/URWDINCond-Medium.woff\") format(\"woff\"),\n    url(\"./font/URWDINCond-Medium.ttf\") format(\"truetype\");\n  font-weight: 500;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
